<script>
  /**
   * Features component
   */
  export default {
    name: 'Features',
  }
</script>

<template>
  <!--START FEATURES-->
  <section class="section" id="features">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-5 order-2 order-lg-1">
          <div class="features-box mt-5 mt-lg-0">
            <h3
              >Somos DIU,
              <span style="color: #16407c">Droguería Industrial Uruguaya</span>, Emilio
              Benzo S.A.</h3
            >
            <p class="text-muted web-desc"
              >Nacida en el año 1935, con más de 85 años de trayectoria en el mercado, se ha
              dedicado a la
              <span style="color: #16407c"><b>producción e importación</b></span
              >, con foco en el fraccionamiento de productos químicos en general.
              <br /><br />Nos abocamos en encontrar soluciones a nuestros clientes a
              través de la venta de productos químicos
              <span style="color: #16407c"><b>para el uso:</b></span>
            </p>
            <ul class="text-muted list-unstyled margin-t-30 features-item-list">
              <li style="color: #16407c"><b>Industrial</b></li>
              <li style="color: #16407c"><b>Comercial</b></li>
              <li style="color: #16407c"><b>Doméstico</b></li>
              <li style="color: #16407c"><b>Humano</b></li>
              <li style="color: #16407c"><b>Clínico</b></li>              
            </ul>
          </div>
        </div>
        <div class="col-lg-7 order-1 order-lg-2">
          <div class="features-img mx-auto mr-lg-0">
            <img
              src="@/assets/images/banner.3.png"
              alt="macbook image"
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container pt-2 pt-sm-3 pt-md-4 pt-lg-5">
      <div class="row align-items-center">
        <div class="col-lg-7 order-1 order-lg-2">
          <div class="features-box">
            <h3>FRANQUICIAS DIU</h3>
            <p class="text-muted web-desc"
              >Consiste en un
              <span style="color: #16407c"><b>retail “tradicional”</b></span> con venta al
              mostrador asistida y una atención personalizada a través de vendedores/as
              profesionales. <br /><br />Nos caracteriza el
              <span style="color: #16407c"
                ><b>conocimiento de nuestros productos</b></span
              >
              y el <span style="color: #16407c"><b>asesoramiento integral</b></span> a
              todos nuestros clientes.<br /><br />Brindamos siempre, una
              <span style="color: #16407c"><b>atención esmerada y profesional.</b></span>
            </p>

            <a href="#contact" class="btn btn-custom margin-t-30">
              Solicita tu franquicia
              <i class="mdi mdi-arrow-right"></i>
            </a>
          </div>
        </div>
        <div class="col-lg-5 order-2 order-lg-1">
          <div class="features-img mx-auto mr-lg-0">
            <img src="@/assets/images/local.1.png" alt="macbook image" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--END FEATURES-->
</template>
